var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 17H6.0625C5.81641 17 5.625 17.2188 5.625 17.4375V18.3125C5.625 18.5586 5.81641 18.75 6.0625 18.75H17.4375C17.6562 18.75 17.875 18.5586 17.875 18.3125V17.4375C17.875 17.2188 17.6562 17 17.4375 17ZM19.1875 8.25C18.4492 8.25 17.875 8.85156 17.875 9.5625C17.875 9.78125 17.9023 9.94531 17.9844 10.1094L16.0156 11.3125C15.5781 11.5586 15.0312 11.4219 14.7852 10.9844L12.5703 7.07422C12.8711 6.85547 13.0625 6.47266 13.0625 6.0625C13.0625 5.35156 12.4609 4.75 11.75 4.75C11.0117 4.75 10.4375 5.35156 10.4375 6.0625C10.4375 6.47266 10.6289 6.85547 10.9023 7.07422L8.6875 10.9844C8.44141 11.4219 7.89453 11.5586 7.48438 11.3125L5.48828 10.1094C5.57031 9.94531 5.625 9.78125 5.625 9.5625C5.625 8.85156 5.02344 8.25 4.3125 8.25C3.57422 8.25 3 8.85156 3 9.5625C3 10.3008 3.57422 10.875 4.3125 10.875C4.36719 10.875 4.44922 10.875 4.50391 10.875L6.5 16.125H17L18.9688 10.875C19.0234 10.875 19.1055 10.875 19.1875 10.875C19.8984 10.875 20.5 10.3008 20.5 9.5625C20.5 8.85156 19.8984 8.25 19.1875 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.4e5e59cb706bc97698c4398e64d98798.svg";
export { ForwardRef as ReactComponent };